import { TecidoList } from "./../tecidos-captados/tecido";
import { Coletor } from "./../coletor/coletor";
import { Doador } from "./../doador/doador";
import { Component, EventEmitter, Inject, OnInit } from "@angular/core";
import { UserService } from "src/app/core/user/user.service";
import { Observable } from "rxjs";
import { User } from "src/app/core/user/user";

@Component({
  selector: "app-pdf-termo-page",
  templateUrl: "./pdf-termo-page.component.html",
  styleUrls: ["./pdf-termo-page.component.css"],
})
export class PdfTermoPageComponent implements OnInit {
  doador: Doador;
  coletor: Coletor;
  listaTecidosCapatados: TecidoList;
  tecidosCaptados: string[] = [];
  idadeDoador: string;
  campoVazio: string = "XXX";
  nomeCPC: string;
  crp: string;
  numeroOrgaoRegulador: string;
  termoValido: boolean;
  emitter: EventEmitter<void> = new EventEmitter();
  user$: Observable<User>;

  constructor(private userService: UserService) {
    this.user$ = this.userService.getUser();
  }

  ngOnInit(): void {
    this.idade();
    this.userSubscribe();
  }

  ngAfterViewInit(): void {
    this.emitter.emit();
  }

  tecidos(): string {
    for (let i in this.listaTecidosCapatados) {
      this.tecidosCaptados.push(
        this.listaTecidosCapatados[i].sitio +
          " " +
          this.listaTecidosCapatados[i].nome
      );
    }

    let tecidos = this.tecidosCaptados.join(", ");
    return tecidos;
  }

  idade() {
    try {
      let dataNascimento = this.doador.dataNascimento;
      let dataN = dataNascimento.split("-");
      let dataA = dataN[0];
      let dataM = dataN[1];
      let dataD = dataN[2];
      let date = new Date();
      let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

      let dataNascimentoFormatada = new Date(dataNFormatada);
      this.idadeDoador = this.calcularIdade(dataNascimentoFormatada, date) + "";
    } catch (e) {}
  }

  calcularIdade(nascimento, hoje) {
    var idade = hoje.getFullYear() - nascimento.getFullYear();
    if (
      new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
      new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())
    )
      idade--;
    return idade;
  }

  userSubscribe() {
    this.user$.subscribe(
      (user) =>
        (this.crp = user.orgaoRegulador.includes("null")
          ? ""
          : user.orgaoRegulador)
    );

    this.user$.subscribe((user) => {
      console.log(user);
      this.numeroOrgaoRegulador = user.numeroOrgaoRegulador.includes("null")
        ? ""
        : user.numeroOrgaoRegulador;
    });

    this.user$.subscribe((user) => {
      this.nomeCPC = user.sub;
    });
  }

  doado(destino: string) {
    let doado;
    if (destino === "1") {
      return (doado = "X");
    }
    return (doado = "    ");
  }

  descartado(destino: string) {
    let descartado;
    if (destino === "2") {
      return (descartado = "X");
    }
    return (descartado = "    ");
  }

  dataHoraFinalizacao(): string {
    if (!this.coletor.dataHoraEditarColeta) return;
    let dataHoraFinalizacao = this.coletor.dataHoraEditarColeta;
    let dataN = dataHoraFinalizacao.split("-");
    let dataN2 = dataN[2].split(" ");
    let dataA = dataN[0];
    let dataM = dataN[1];
    let dataD = dataN2[0];
    let dataNFormatada = `${dataD}/${dataM}/${dataA}`;
    let hora = dataN2[1];
    return dataNFormatada + " " + hora;
  }
}
